import { render } from "./form-component.vue?vue&type=template&id=264ff40e&scoped=true"
import script from "./form-component.vue?vue&type=script&lang=js"
export * from "./form-component.vue?vue&type=script&lang=js"

import "./form-component.vue?vue&type=style&index=0&id=264ff40e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ff40e"]])

export default __exports__